import { render, staticRenderFns } from "./DeckComponent.vue?vue&type=template&id=dc7779f2&scoped=true"
import script from "./DeckComponent.vue?vue&type=script&lang=js"
export * from "./DeckComponent.vue?vue&type=script&lang=js"
import style0 from "./DeckComponent.vue?vue&type=style&index=0&id=dc7779f2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc7779f2",
  null
  
)

export default component.exports